import { compose } from 'redux'

// higher-order components
import withSessionLogic from '../FinancialAidInfo/withSessionLogic'
import withState from './withState'
import withRedux from './withRedux'
import withMutation from './withMutation'
import withEventHandlers from './withEventHandlers'

// shared components
import withFormResults from 'components/shared/withFormResults'

// presentational component
import UI from './UI'

const withMutationResults = withFormResults({
  mutation: 'applyForFinancialAid',
  field: 'applyForFinancialAid',
  onSuccess: (data, props) => {
    const { approved, discountAmount } = data.applyForFinancialAid
    if (approved && discountAmount) {
      props.notify({
        message: `Your financial aid application has been approved for a discount of $${(discountAmount / 100).toFixed(2)} off of each day pass!`
      })
    }
  }
})

export default compose(
  withSessionLogic, // for selecting the correct session
  withState, // for form state
  withRedux, // for modal handling
  withMutationResults, // for form results
  withMutation, // for applying for financial aid
  withEventHandlers // for form events
)(UI)
